import { useTranslation } from "gatsby-plugin-react-i18next";
import { Dialog } from "primereact/dialog";
import AdoptAnimalForm from "components/Form/AdoptAnimalForm";
import {
  AnimalName,
  AnimalTraits,
  DetailsContainer,
  ImageContainer,
  AnimalDescription,
  AnimalImageWrapper,
  Thumbnails,
  AnimalDetailsContainer,
  AnimalBasicInfo,
} from "./style";
import { BsHouseHeartFill, BsHouseUpFill } from "react-icons/bs";
import { FaLaptopHouse, FaBirthdayCake } from "react-icons/fa";
import { GiWeight } from "react-icons/gi";
import { Fragment, useMemo, useState } from "react";
import PaymentDialog from "../Payments/PaymentDialog";
import { PhotoProvider, PhotoView } from "react-photo-view";
import Image from "components/Image/Image";
import { Button } from "primereact/button";
import { MdFemale, MdMale } from "react-icons/md";

const adoptionTypeIcon = {
  adoption: <BsHouseHeartFill />,
  virtualAdoption: <FaLaptopHouse />,
  supportFosterHome: <BsHouseUpFill />,
};

const AnimalDetail = ({ animal }) => {
  const { t } = useTranslation();
  const shouldShowAnimalAdoptionForm = useMemo(
    () => ["adoption", "virtualAdoption"].some((k) => animal.category === k),
    [animal.category]
  );
  const [shouldShowDialog, setShouldShowDialog] = useState(false);

  if (!animal) {
    return;
  }

  const mainImage = animal.images[0];

  return (
    <>
      <AnimalDetailsContainer>
        <DetailsContainer margin>
          <AnimalTraits>
            <AnimalName>
              {/* Alternative back button */}
              {/* <AiFillLeftCircle /> */}
              {animal.name}
              {animal.gender === "female" ? (
                <MdFemale fill="#db91db" size="40px" />
              ) : (
                <MdMale fill="#22a7ce" size="40px" />
              )}
            </AnimalName>
            <AnimalBasicInfo>
              <span>
                {adoptionTypeIcon[animal.category]}
                {/* i18next-extract-mark-context-next-line ["adoption", "virtualAdoption", "supportFosterHome"] */}
                <i>{t("category", { context: animal.category })}</i>
              </span>
              <span>
                {animal.years > 0 && (
                  <Fragment>
                    <FaBirthdayCake />
                    <i>{t("yearsOld", { count: animal.years })}</i>
                  </Fragment>
                )}
                {animal.years > 0 && animal.months > 0 && <span>,</span>}
                {animal.months > 0 && (
                  <i>{t("monthsOld", { count: animal.months })}</i>
                )}
              </span>
              <span>
                <GiWeight />
                <i>
                  {animal.weight} {t("kilogramsAbbreviated")}
                </i>
              </span>
              {(animal.category === "virtualAdoption" ||
                animal.category === "supportFosterHome") && (
                  <div style={{ flex: "100%" }}>
                    <PaymentDialog
                      label={
                        animal.category === "supportFosterHome"
                          ? t("supportVirtualHome")
                          : t("adoptVirtually")
                      }
                    />
                  </div>
                )}
            </AnimalBasicInfo>
          </AnimalTraits>
          <AnimalDescription
            dangerouslySetInnerHTML={{ __html: animal.bodyHtml }}
          />
          {shouldShowAnimalAdoptionForm && (
            <>
              <Button
                label={t("adoptionForm")}
                onClick={() => setShouldShowDialog(true)}
              />
              <Dialog
                visible={shouldShowDialog}
                onHide={() => setShouldShowDialog(false)}
                header={t("adoptionForm")}
                style={{ width: "30vw" }}
              >
                <AdoptAnimalForm />
              </Dialog>
            </>
          )}
        </DetailsContainer>
        <ImageContainer>
          <PhotoProvider>
            <PhotoView src={mainImage?.publicURL}>
              <AnimalImageWrapper main>
                <Image
                  item={{
                    imageData: mainImage.childImageSharp.gatsbyImageData,
                  }}
                  alt="animal image"
                  fullHeight
                />
                {/* <Blob /> */}
              </AnimalImageWrapper>
            </PhotoView>
            {animal.images.length > 1 && (
              <Thumbnails>
                {animal.images.slice(1).map((image, index) => (
                  <PhotoView key={index} src={image.publicURL}>
                    <AnimalImageWrapper>
                      <Image
                        item={{
                          imageData: image.childImageSharp.gatsbyImageData,
                        }}
                        alt="animal image"
                        fullWidth
                        fullHeight
                      />
                    </AnimalImageWrapper>
                  </PhotoView>
                ))}
              </Thumbnails>
            )}
          </PhotoProvider>
        </ImageContainer>
      </AnimalDetailsContainer>
    </>
  );
};

export default AnimalDetail;
